import { LABELS_BY_LOCALES } from '../constants/locales';

export const getLocaleOptions = () =>
  Object.entries(LABELS_BY_LOCALES).map(([value, label]) => ({
    label: `${label} (${value})`,
    value,
  }));
